export default "__VITE_ASSET__BNVzClzC__"